module.exports = __webpack_public_path__ + "img/default.cf89e8e6.png";